import { render, staticRenderFns } from "./ElementTransformProperties.vue?vue&type=template&id=3a8543c4&scoped=true"
import script from "./ElementTransformProperties.vue?vue&type=script&setup=true&lang=ts"
export * from "./ElementTransformProperties.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ElementTransformProperties.vue?vue&type=style&index=0&id=3a8543c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8543c4",
  null
  
)

export default component.exports